import React, { useState, useEffect } from "react";
import { Typography, Spin } from "antd";
import { handleErrorNavigation } from "pages/ErrorPage/ErrorHandler";
import { useSurveySrv } from "pages/Survey/useSurveySrv";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { MedicardData } from "./types";
import { resolveTemplate } from "./templateRegistry";
const { Text } = Typography;
const defaultMemberData: MedicardData = {
  PatientName: "",
  MedicaidID: "",
  MedicaidEffectiveDate: "",
  Product: "",
  PCPName: "",
  PCPPhone: "",
  RX: "",
  RXBin: "",
  RXPCN: "",
  RXGroup: "",
  MedicardLayoutCode: ""
};

declare const require: (name: string) => string;

let logo: string;

try {
  logo = require("@assets/idLogo.png");
} catch (e) {
  logo = require("@assets/logo.png");
}

const MedicardLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { getMedicaidIDCardData } = useSurveySrv();
  const [memberData, setMemberData] = useState<MedicardData>(defaultMemberData);
  const [templateName, setTemplateName] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const formatPhone = (phone: string): string => {
    const digits = phone?.replace(/\D/g, "") ?? "";
    if (digits.length === 10) {
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }
    return phone ?? "";
  };
  useEffect(() => {
    const fetchCardData = async () => {
      setLoading(true);
      try {
        const res: any = await getMedicaidIDCardData();
        const actualData = res && typeof res === "object" && "data" in res ? res.data : res ?? {};
        const formattedData: MedicardData = {
          PatientName:
            (actualData.PatientFirstName ?? "") +
            (actualData.PatientLastName
              ? " " + actualData.PatientLastName
              : ""),

          MedicaidID: actualData.MedicaidID ?? "",
          MedicaidEffectiveDate: moment(
            actualData.MedicaidEffectiveDate
          ).format("MM/DD/YYYY"),
          Product: actualData.Product ?? "",
          PCPName: actualData.PCPName ?? "",
          PCPPhone: formatPhone(actualData.PCPPhone),
          RX: actualData.RX ?? "",
          RXBin: actualData.RXBin ?? "",
          RXPCN: actualData.RXPCN ?? "",
          RXGroup: actualData.RXGroup ?? "",
          MedicardLayoutCode: actualData.MedicardLayoutCode ?? "",
          MedicardNurseAdviceLinePhone: actualData.MedicardNurseAdviceLinePhone ?? "",
          MedicardNurseAdviceLineTollFree: actualData.MedicardNurseAdviceLineTollFree ?? "",
          MedicardNurseAdviceLineTTY: actualData.MedicardNurseAdviceLineTTY ?? "",
          MedicardMemberServicesPhone: actualData.MedicardMemberServicesPhone ?? "",
          MedicardMemberServicesTollFree: actualData.MedicardMemberServicesTollFree ?? "",
          MedicardMemberServicesTTY: actualData.MedicardMemberServicesTTY ?? "",
          MedicardMemberServicesWebsite: actualData.MedicardMemberServicesWebsite ?? "",
          MedicardSupportedServices: actualData.MedicardSupportedServices ?? "",
          MedicardSupportTollFreePhone: actualData.MedicardSupportTollFreePhone ?? "",
          MedicardSupportTTYPhone: actualData.MedicardSupportTTYPhone ?? "",
          MedicardClaimPayName: actualData.MedicardClaimPayName ?? "",
          MedicardClaimAttention: actualData.MedicardClaimAttention ?? "",
          MedicardClaimAddress1: actualData.MedicardClaimAddress1 ?? "",
          MedicardClaimAddress2: actualData.MedicardClaimAddress2 ?? null,
          MedicardClaimsCity: actualData.MedicardClaimsCity ?? "",
          MedicardClaimsState: actualData.MedicardClaimsState ?? "",
          MedicardClaimsZipCode: actualData.MedicardClaimsZipCode ?? "",
          MedicardProviderSupportedServices: actualData.MedicardProviderSupportedServices ?? "",
          MedicardProviderSupportPhone: actualData.MedicardProviderSupportPhone ?? "",
          MedicardProviderPortalWebsite: actualData.MedicardProviderPortalWebsite ?? "",
          MedicardPayorId: actualData.MedicardPayorId ?? "",
        };
        setMemberData(formattedData);
        setTemplateName(actualData.MedicardLayoutCode ?? "");
        //  setTemplateName("Layout1");
      } catch (error) {
        handleErrorNavigation(error, navigate, t);
      } finally {
        setLoading(false);
      }
    };

    fetchCardData();
  }, []);

  if (loading) {
    return (
      <div className="card-container" style={{ textAlign: "center", padding: 50 }}>
        <Spin size="large" />
        <div style={{ marginTop: 20 }}>
          <Text>Loading member data...</Text>
        </div>
      </div>
    );
  }

  const Template = resolveTemplate(templateName);
  if (!Template) return null;
  return <Template data={memberData} logo={logo} t={t} />;
};

export default MedicardLayout;

